export const ARTICLE_NAV = [
  {
    "title": "Artikel & Tips",
    "link": "#",
    "childItems": [
      {
        "title": "Mengerti Asuransi",
        "link": "#",
        "childItems": [
          {
            "title": "Polis Asuransi",
            "link": "/media/asuransi/polis-asuransi/",
          },
          {
            "title": "Premi Asuransi",
            "link": "/media/asuransi/premi-asuransi/",
          },
          {
            "title": "Jenis Asuransi",
            "link": "/media/asuransi/jenis-asuransi/",
          },
          {
            "title": "Risiko Asuransi",
            "link": "/media/asuransi/risiko-asuransi/",
          },
          {
            "title": "Klaim Asuransi",
            "link": "/media/asuransi/klaim-asuransi/",
          }
        ],
      },
      {
        "title": "Artikel Lainnya",
        "link": "#",
        "childItems": [
          {
            "title": "Semua Artikel",
            "link": "/media/",
          },
          {
            "title": "Tips Asuransi",
            "link": "/media/asuransi/",
          },
          {
            "title": "Tips Asuransi Mobil",
            "link": "/media/asuransi-mobil/",
          },
          {
            "title": "Tips Asuransi Kesehatan",
            "link": "/media/asuransi-kesehatan/",
          },
          {
            "title": "Review Perusahaan Asuransi",
            "link": "/media/perusahaan-asuransi/",
          },
          {
            "title": "Tips Kendaraan & Asuransi",
            "link": "/media/tips-kendaraan-asuransi/",
          },
          {
            "title": "Tips Kesehatan & Asuransi",
            "link": "/media/tips-kesehatan-asuransi/",
          },
          {
            "title": "Kalkulator",
            "link": "/media/kalkulator/",
          }
        ],
      }
    ],
  },
]